import PropTypes from "prop-types"
import React from "react"
import {
  Typography,
  FormControlLabel,
  RadioGroup,
  Radio,
  Box,
} from "@material-ui/core"

import useStyles from "./styles"

const PaymentMethod = ({ method, handleChange, checkPaymentAllowed }) => {
  const classes = useStyles()
  return (
    <Box mt={2} mb={2}>
      <Typography variant="h5">Payment Method:</Typography>
      <RadioGroup
        aria-label="select-payment-method"
        name="payment-method"
        value={method}
        onChange={handleChange}
        className={classes.radioGroup}
      >
        <FormControlLabel
          className={classes.radio}
          value="card"
          control={<Radio />}
          label="Credit Card"
        />
        <FormControlLabel
          className={classes.radio}
          value="ach"
          control={<Radio />}
          label="ACH"
        />
        {Boolean(checkPaymentAllowed) && (
          <FormControlLabel
            className={classes.radio}
            value="check"
            control={<Radio />}
            label="Check/Transfer"
          />
        )}
      </RadioGroup>
    </Box>
  )
}

PaymentMethod.propTypes = {
  method: PropTypes.string,
  handleChange: PropTypes.func,
  checkPaymentAllowed: PropTypes.number,
}

export default PaymentMethod
